import { render } from "./ContactInfoPanel.vue?vue&type=template&id=2d444108&scoped=true"
import script from "./ContactInfoPanel.vue?vue&type=script&lang=js"
export * from "./ContactInfoPanel.vue?vue&type=script&lang=js"

import "./ContactInfoPanel.vue?vue&type=style&index=0&id=2d444108&scoped=true&lang=css"

import exportComponent from "/home/adelaplace/PycharmProjects/pumping_tool_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d444108"]])

export default __exports__